import { useCallback, useEffect, useState } from 'react';

import logger from '@/logger';
import useStore from '@/store';

import useFirebase from '../hooks/useFirestore';

interface TestData {
  id?: string;
  name: string;
}

interface SubjectCard {
  subjectId: string;
  timestamp: string;
}

export default function FirebaseTest() {
  const [data, setData] = useState<TestData[]>([]);
  const { currentStudent } = useStore();
  const { getArrayField, appendToArrayField } = useFirebase();
  const [studentId, setStudentId] = useState<string>(currentStudent?.id || '');

  const fetchDocuments = useCallback(async () => {
    try {
      const documents = await getArrayField<TestData>(studentId, 'subjectCards');
      setData(documents);
    } catch (error) {
      logger.error('Error fetching data:', error);
    }
  }, [getArrayField, studentId]);

  const addDemoSubjectCard = useCallback(async () => {
    try {
      const newSubjectCard: SubjectCard = {
        subjectId: 'dcad3f1b-db74-448a-af5c-dd82e3115192',
        timestamp: new Date().toISOString(),
      };

      await appendToArrayField(studentId, 'subjectCards', newSubjectCard);
      logger.log('Demo subject card added successfully');
      void fetchDocuments();
    } catch (error) {
      logger.error('Error adding demo subject card:', error);
    }
  }, [appendToArrayField, studentId, fetchDocuments]);

  const onStudentIdChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setStudentId(event.target.value);
  }, []);

  const onAddCard = useCallback(() => {
    void addDemoSubjectCard();
  }, [addDemoSubjectCard]);

  useEffect(() => {
    void fetchDocuments();
  }, [fetchDocuments]);

  return (
    <div className="p-4">
      <h2 className="mb-4 text-xl font-bold">Firebase Test</h2>

      <div className="mb-4">
        <input
          type="text"
          value={currentStudent?.id}
          onChange={onStudentIdChange}
          placeholder="Enter Student ID"
          className="mr-2 rounded border p-2"
        />
        <button
          type="button"
          onClick={onAddCard}
          className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
        >
          Add Demo Subject Card
        </button>
      </div>

      <div className="mt-4">
        <h3 className="mb-2 font-semibold">Data from Firestore:</h3>
        <ul className="space-y-2">
          {data.map((item) => (
            <li key={item.id} className="rounded border p-2">
              {item.name} - {new Date(item.timestamp).toLocaleString()}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
